//import { Link } from 'react-router-dom' 

const Footer = () => {
    return (
        <footer>
            <p align="center">Copyright &copy; Júlia Sato 2021</p>
            {/*<Link to='/about'>About</Link>*/}
        </footer>
    )
}

export default Footer